import i18n from "@/i18n";
import classNames from "classnames";
import BFButton from "../../general/Button/BFButton";
import {
  BFInputVariableIndicator,
  DEFAULT_INPUT_VARIABLE_INDICATOR,
} from "./BFInputVariables";
import "./BFInputVariablesOverlay.scss";

export type BFInputVariableConfigProps = {
  indicator?: BFInputVariableIndicator;
  data: string[];
};
type BFInputVariablesOverlayProps = BFInputVariableConfigProps & {
  variableString: string;
  onVariableSelect: (variable: string) => void;
};
const BFInputVariablesOverlay = (props: BFInputVariablesOverlayProps) => {
  const indicator = props.indicator || DEFAULT_INPUT_VARIABLE_INDICATOR;

  const cleanedVariableString = (props.variableString || "").replace(
    new RegExp(`\\${indicator.pre}|\\${indicator.post}`, "g"),
    ""
  );
  const matchingVariables = props.data.filter((variable) =>
    variable.toLowerCase().includes(cleanedVariableString.toLowerCase())
  );

  const nonMatchinvVariables = props.data.filter(
    (variable) => !matchingVariables.includes(variable)
  );

  return (
    <div className={classNames("bf-input-variables")}>
      <div className={`matching-variables`}>
        {matchingVariables.map((variable) => (
          <BFButton
            noRadius
            className={`matching-variable`}
            appearance="clear-on-white"
            key={variable}
            onClick={() =>
              props.onVariableSelect(indicator.pre + variable + indicator.post)
            }
          >
            {variable}
          </BFButton>
        ))}
        {matchingVariables.length === 0 && (
          <div className={`no-matching-variables`}>
            {i18n.t(
              "BFInput.noMatchingVariables",
              "Keine passenden Variablen gefunden"
            )}
          </div>
        )}
      </div>
      {nonMatchinvVariables.length > 0 && (
        <div className={`non-matching-variables`}>
          <div className={`non-matching-variables-header`}>
            {i18n.t(
              "BFInput.suggestionVariables",
              "Nutzen Sie eine der folgenden Variablen"
            )}
            :
          </div>
          <div className={`non-matching-variables-list`}>
            {nonMatchinvVariables.map((variable) => (
              <BFButton
                size="xs"
                appearance="outline"
                key={variable}
                onClick={() =>
                  props.onVariableSelect(
                    indicator.pre + variable + indicator.post
                  )
                }
              >
                {variable}
              </BFButton>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BFInputVariablesOverlay;
